export enum ClientAccountType {
  linkedin = 'LINKEDIN',
  email = 'EMAIL'
}
